import features from "../../registries/util/geo-map-definition.json";

export interface ICasesMapInputs {
  data: any;
  domain: number[];
  features: any;
}

export const getPublicCasesMapChart = (dataCharts): ICasesMapInputs | null => {
  const featuresIn: any = features.features;

  const dataIn = dataCharts;

  const casesMapInputs: ICasesMapInputs = {
    features: featuresIn,
    ...dataIn,
  };

  return casesMapInputs;
};
